import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import ContentInput from "../../components/common/ContentInput";
import ValidMsgSpan from "../../components/common/ValidMsgSpan";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import { useTranslation } from "react-i18next";

const FindInfoPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [emailForId, setEmailForId] = useState("");
  const [regionForId, setRegionForId] = useState("");
  const [countryForId, setCountryForId] = useState("");
  const [typeForId, setTypeForId] = useState("");
  const [regCodeForId, setRegCodeForId] = useState("");

  const [idForEmail, setIdForEmail] = useState("");
  const [regionForEmail, setRegionForEmail] = useState("");
  const [countryForEmail, setCountryForEmail] = useState("");
  const [typeForEmail, setTypeForEmail] = useState("");
  const [regCodeForEmail, setRegCodeForEmail] = useState("");

  const [emailForPwd, setEmailForPwd] = useState("");

  const [sbRegion, setSbRegion] = useState([
    { code: "", codeDesc: `${t("L0049")}  *` },
  ]);
  const [sbCountryForId, setSbCountryForId] = useState([
    { code: "", codeDesc: `${t("L0050")}  *` },
  ]);
  const [sbTypeForId, setSbTypeForId] = useState([
    { code: "", codeDesc: `${t("L0031")}  *` },
  ]);
  const [sbRegForId, setSbRegForId] = useState([
    { code: "", codeDesc: `${t("L0051")}  *` },
  ]);

  const [sbCountryForEmail, setSbCountryForEmail] = useState([
    { code: "", codeDesc: `${t("L0050")}  *` },
  ]);
  const [sbTypeForEmail, setSbTypeForEmail] = useState([
    { code: "", codeDesc: `${t("L0031")}  *` },
  ]);
  const [sbRegForEmail, setSbRegForEmail] = useState([
    { code: "", codeDesc: `${t("L0051")}  *` },
  ]);

  useEffect(() => {
    loadRegionData();
  }, []);

  useEffect(() => {
    if (regionForId == "") {
      setSbCountryForId([{ code: "", codeDesc: `${t("L0050")}  *` }]);
      setCountryForId("");
    }
    if (countryForId == "") {
      setSbTypeForId([{ code: "", codeDesc: `${t("L0031")}  *` }]);
      setTypeForId("");
    }
    if (typeForId == "") {
      setRegCodeForId("");
      setSbRegForId([{ code: "", codeDesc: `${t("L0051")}  *` }]);
    }
  }, [typeForId, countryForId, regionForId]);

  const loadRegionData = () => {
    api
      .post("/user/code/united", {})
      .then((response) => {
        setSbRegion([
          { code: "", codeDesc: `${t("L0049")}  *` },
          ...response.data,
        ]);
      })
      .catch((error) => {
        //TODO
      });
  };

  const handleEmailForIdChange = (e) => {
    setEmailForId(e.target.value.trim());
  };

  const handleRegionForIdChange = async (e) => {
    setRegionForId(e.target.value);

    try {
      const response = await api.post("/user/code/country", {
        sRegion: e.target.value,
      });

      setSbCountryForId([
        { code: "", codeDesc: `${t("L0050")} *` },
        ...response.data,
      ]);
      setCountryForId("");
      setSbTypeForId([{ code: "", codeDesc: `${t("L0031")} *` }]);
      setTypeForId("");
      setSbRegForId([{ code: "", codeDesc: `${t("L0051")} *` }]);
      setRegCodeForId("");
    } catch (error) {}
  };

  const handleRegionForEmailChange = async (e) => {
    setRegionForEmail(e.target.value);

    try {
      const response = await api.post("/user/code/country", {
        sRegion: e.target.value,
      });

      setSbCountryForEmail([
        { code: "", codeDesc: `${t("L0050")} *` },
        ...response.data,
      ]);
      setCountryForEmail("");
      setSbTypeForEmail([{ code: "", codeDesc: `${t("L0031")} *` }]);
      setTypeForEmail("");
      setSbRegForEmail([{ code: "", codeDesc: `${t("L0051")} *` }]);
      setRegCodeForEmail("");
    } catch (error) {}
  };

  const handleCountryForIdChange = (e) => {
    setCountryForId(e.target.value);

    api
      .post("/user/code/type", {})
      .then((response) => {
        setSbTypeForId([
          { code: "", codeDesc: `${t("L0031")}  *` },
          ...response.data,
        ]);
        setTypeForId("");
        setSbRegForId([{ code: "", codeDesc: `${t("L0051")} *` }]);
        setRegCodeForId("");
      })
      .catch((error) => {
        //TODO
      });
  };

  const handleCountryForEmailChange = (e) => {
    setCountryForEmail(e.target.value);

    api
      .post("/user/code/type", {})
      .then((response) => {
        setSbTypeForEmail([
          { code: "", codeDesc: `${t("L0031")}  *` },
          ...response.data,
        ]);
        setTypeForEmail("");
        setSbRegForEmail([{ code: "", codeDesc: `${t("L0051")} *` }]);
        setRegCodeForEmail("");
      })
      .catch((error) => {});
  };

  const handleTypeForIdChange = (e) => {
    setTypeForId(e.target.value);

    api
      .post("/user/code/registration", {
        sRegion: regionForId,
        sCountry: countryForId,
        sType: e.target.value,
      })
      .then((response) => {
        setSbRegForId([
          { code: "", codeDesc: `${t("L0051")}  *` },
          ...response.data,
        ]);
        setRegCodeForId("");
      })
      .catch((error) => {});
  };

  const handleTypeForEmailChange = (e) => {
    setTypeForEmail(e.target.value);

    api
      .post("/user/code/registration", {
        sRegion: regionForEmail,
        sCountry: countryForEmail,
        sType: e.target.value,
      })
      .then((response) => {
        setSbRegForEmail([
          { code: "", codeDesc: `${t("L0051")}  *` },
          ...response.data,
        ]);
        setRegCodeForEmail("");
      })
      .catch((error) => {});
  };

  const handleRegCodeForIdChange = (e) => {
    setRegCodeForId(e.target.value);
  };

  const handleRegCodeForEmailChange = (e) => {
    setRegCodeForEmail(e.target.value);
  };

  const handleIdForEmailChange = (e) => {
    setIdForEmail(e.target.value.trim());
  };

  const handleSearchForIdClick = () => {
    if (!validateForId()) {
      return;
    }

    api
      .post("/user/idfind", {
        email: emailForId,
        loc: regCodeForId,
      })
      .then((response) => {
        let tempErrors = {};
        tempErrors.validFindId = `${t("L0372")} '${response.data}'`;
        setErrorsForId(tempErrors);
      })
      .catch(() => {
        let tempErrors = {};
        tempErrors.validFindId = t("L1089");
        setErrorsForId(tempErrors);
      });
  };

  const handleSearchForEmailClick = () => {
    if (!validateForEmail()) {
      return;
    }
    api
      .post("/user/emailfind", {
        userId: idForEmail,
        loc: regCodeForEmail,
      })
      .then((response) => {
        let tempErrors = {};
        tempErrors.validFindEmail = `${t("L0375")} '${response.data}'`;
        setErrorsForEmail(tempErrors);
      })
      .catch(() => {
        let tempErrors = {};
        tempErrors.validFindEmail = t("L1089");
        setErrorsForEmail(tempErrors);
      });
  };

  const handleEmailForPwdChange = (e) => {
    setEmailForPwd(e.target.value.trim());
  };

  const handleSubmitForPwdClick = () => {
    if (!validateForPwd()) {
      return;
    }
    api
      .post("/user/initpwd", {
        email: emailForPwd,
      })
      .then(() => {
        let tempErrors = {};
        tempErrors.validPwd = t("L0028");
        setErrorsForPwd(tempErrors);
      })
      .catch((error) => {
        if (error.response.data.result == "1040") {
          let tempErrors = {};
          tempErrors.validPwd = "Email is not correct.";
          setErrorsForPwd(tempErrors);
        } else {
          let tempErrors = {};
          tempErrors.validPwd = "Sorry. Initialize Password was failed.";
          setErrorsForPwd(tempErrors);
        }
      });
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  const [errorsForId, setErrorsForId] = useState({
    validEmail: "",
    validReg: "",
    validFindId: "",
  });

  const validateForId = () => {
    let tempErrors = {};
    let isValid = true;

    if (!emailForId) {
      tempErrors.validEmail = "User Email is required.";
      isValid = false;
    }

    if (!regionForId || !countryForId || !typeForId || !regCodeForId) {
      tempErrors.validReg = "Region/Type/Dist is required.";
      isValid = false;
    }

    setErrorsForId(tempErrors);
    return isValid;
  };

  const [errorsForEmail, setErrorsForEmail] = useState({
    validId: "",
    validReg: "",
    validFindEmail: "",
  });

  const validateForEmail = () => {
    let tempErrors = {};
    let isValid = true;

    if (!idForEmail) {
      tempErrors.validId = "User ID is required.";
      isValid = false;
    }

    if (
      !regionForEmail ||
      !countryForEmail ||
      !typeForEmail ||
      !regCodeForEmail
    ) {
      tempErrors.validReg = "Region/Type/Dist is required.";
      isValid = false;
    }

    setErrorsForEmail(tempErrors);
    return isValid;
  };

  const [errorsForPwd, setErrorsForPwd] = useState({
    validEmail: "",
    validPwd: "",
  });

  const validateForPwd = () => {
    let tempErrors = {};
    let isValid = true;

    if (!emailForPwd) {
      tempErrors.validEmail = "User Email is required.";
      isValid = false;
    }
    setErrorsForPwd(tempErrors);
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("L0341"), t("L0367")]}></BreadCrumbDiv>

      {/* Find ID */}
      <InputWrapDiv className="mb50">
        <TopBoxDiv value={t("L0368")}></TopBoxDiv>

        <table>
          <tbody>
            <tr>
              <th>
                {t("L0369")}
                {errorsForId.validEmail && (
                  <>
                    <br />
                    <ValidMsgSpan value={errorsForId.validEmail}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td colSpan={2}>
                <ContentInput
                  value={emailForId}
                  width="100%"
                  maxLength={250}
                  onChange={handleEmailForIdChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0370")}
                {errorsForId.validReg && (
                  <>
                    <br />
                    <ValidMsgSpan value={errorsForId.validReg}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <CodeSelectBox
                  value={regionForId}
                  codes={sbRegion}
                  onChange={handleRegionForIdChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="20%"
                  style={{ backgroundColor: "#f6f3f2" }}
                ></CodeSelectBox>

                <CodeSelectBox
                  value={countryForId}
                  codes={sbCountryForId}
                  onChange={handleCountryForIdChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="25%"
                  style={{ backgroundColor: "#f6f3f2" }}
                ></CodeSelectBox>

                <CodeSelectBox
                  value={typeForId}
                  codes={sbTypeForId}
                  onChange={handleTypeForIdChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="25%"
                  style={{ backgroundColor: "#f6f3f2" }}
                ></CodeSelectBox>

                <CodeSelectBox
                  value={regCodeForId}
                  codes={sbRegForId}
                  onChange={handleRegCodeForIdChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="25%"
                  style={{ backgroundColor: "#f6f3f2" }}
                ></CodeSelectBox>
              </td>
              <td style={{ width: "80px" }}>
                <FunctionButton
                  value={t("L0090")}
                  className="small"
                  onClick={handleSearchForIdClick}
                ></FunctionButton>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="tc">
          {errorsForId.validFindId && (
            <>
              <br />
              <ValidMsgSpan
                value={errorsForId.validFindId}
                className={"f14"}
              ></ValidMsgSpan>
            </>
          )}
        </div>
      </InputWrapDiv>
      <br />

      {/* Find Email */}
      <InputWrapDiv className="mb50">
        <TopBoxDiv value={t("L0373")}></TopBoxDiv>

        <table>
          <tbody>
            <tr>
              <th>
                {t("L0185")}
                {errorsForEmail.validId && (
                  <>
                    <br />
                    <ValidMsgSpan value={errorsForEmail.validId}></ValidMsgSpan>
                  </>
                )}
              </th>
              <td colSpan={2}>
                <ContentInput
                  value={idForEmail}
                  width="100%"
                  maxLength={250}
                  onChange={handleIdForEmailChange}
                ></ContentInput>
              </td>
            </tr>
            <tr>
              <th>
                {t("L0370")}
                {errorsForEmail.validReg && (
                  <>
                    <br />
                    <ValidMsgSpan
                      value={errorsForEmail.validReg}
                    ></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <CodeSelectBox
                  value={regionForEmail}
                  codes={sbRegion}
                  onChange={handleRegionForEmailChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="20%"
                  style={{ backgroundColor: "#f6f3f2" }}
                ></CodeSelectBox>

                <CodeSelectBox
                  value={countryForEmail}
                  codes={sbCountryForEmail}
                  onChange={handleCountryForEmailChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="25%"
                  style={{ backgroundColor: "#f6f3f2" }}
                ></CodeSelectBox>

                <CodeSelectBox
                  value={typeForEmail}
                  codes={sbTypeForEmail}
                  onChange={handleTypeForEmailChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="25%"
                  style={{ backgroundColor: "#f6f3f2" }}
                ></CodeSelectBox>

                <CodeSelectBox
                  value={regCodeForEmail}
                  codes={sbRegForEmail}
                  onChange={handleRegCodeForEmailChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="25%"
                  style={{ backgroundColor: "#f6f3f2" }}
                ></CodeSelectBox>
              </td>
              <td style={{ width: "80px" }}>
                <FunctionButton
                  value={t("L0090")}
                  className="small"
                  onClick={handleSearchForEmailClick}
                ></FunctionButton>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="tc">
          {errorsForEmail.validFindEmail && (
            <>
              <br />
              <ValidMsgSpan
                value={errorsForEmail.validFindEmail}
                className={"f14"}
              ></ValidMsgSpan>
            </>
          )}
        </div>
      </InputWrapDiv>
      <br />

      {/* Initialize Password */}
      <InputWrapDiv>
        <TopBoxDiv value={t("L0377")}>
          <p>{t("L0378")}</p>
        </TopBoxDiv>

        <table>
          <tbody>
            <tr>
              <th>
                {t("L0003")}
                {errorsForPwd.validEmail && (
                  <>
                    <br />
                    <ValidMsgSpan
                      value={errorsForPwd.validEmail}
                    ></ValidMsgSpan>
                  </>
                )}
              </th>
              <td>
                <ContentInput
                  value={emailForPwd}
                  width="100%"
                  maxLength={250}
                  onChange={handleEmailForPwdChange}
                ></ContentInput>
              </td>
              <td style={{ width: "80px" }}>
                <FunctionButton
                  value={t("L0659")}
                  className="small"
                  onClick={handleSubmitForPwdClick}
                ></FunctionButton>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="tc">
          {errorsForPwd.validPwd && (
            <>
              <br />
              <ValidMsgSpan
                value={errorsForPwd.validPwd}
                className={"f14"}
              ></ValidMsgSpan>
            </>
          )}
        </div>
      </InputWrapDiv>

      <ButtonWrapDiv className="btn_bottom">
        <FunctionButton
          value={t("L0188")}
          className="big"
          onClick={handleLoginClick}
        ></FunctionButton>
      </ButtonWrapDiv>
    </div>
  );
};

export default FindInfoPage;
